import { i18n } from '@/locales';
const lc = 'views.hub_management.';
// Y : 원클릭, N : 투클릭, S : 투클릭 + 밀어잡기
const workerOneClickBaechaYnOptionList = [
    'Y',
    'N',
    'S',
];
export default workerOneClickBaechaYnOptionList.map((code, index) => ({
    text: i18n.t(`${lc}worker_one_click_baecha_yn_type_list[${index}]`),
    value: code,
}));
